/** Flatten MUI sx arrays without duplication at call sites. */
export function mergeSx(...parts) {
  return parts
    .filter(Boolean)
    .flatMap((part) => (Array.isArray(part) ? part : [part]));
}
